// Zustimmungsnachweis für die Kasse (§ 312f Abs. 3, § 356 Abs. 6 BGB). Die beiden Pflicht-Häkchen im
// Warenkorb (CartSidebar.jsx) und im Abo-Dialog (AboZustimmung.jsx) wurden bisher nur im Browser geprüft;
// jetzt gehen sie beim Start der Kasse mit an den Server (create-cart-checkout bzw. create-checkout).
// server.py speichert sie an der Bestellung bzw. am Abo, schreibt sie in die Stripe-Metadaten und
// bestätigt sie in der Kauf-Mail mit Zeitpunkt und Wortlaut (ZUSTIMMUNG_FASSUNGEN).
//
// WORTLAUT DER HÄKCHEN GEÄNDERT? Dann ZUSTIMMUNG_FASSUNG hochzählen UND in server.py unter
// ZUSTIMMUNG_FASSUNGEN den neuen Wortlaut (DE + EN) ergänzen — alte Fassungen dort stehen lassen.
export const ZUSTIMMUNG_FASSUNG = 'kasse-2026-10b';  // b: Paragraf § 356 Abs. 6 Nr. 2 statt Abs. 5

// Felder für den Kassen-Start. agb/verzicht = Stand der beiden Häkchen, en = Sprache der Seite
// (bestimmt auch die Sprache der Kauf-Mail und der angehängten AGB/Widerrufsbelehrung).
export const zustimmungFelder = ({ agb, verzicht, en }) => ({
  consent_terms: !!agb,
  consent_execution: !!verzicht,
  consent_text_version: ZUSTIMMUNG_FASSUNG,
  consent_at: new Date().toISOString(),
  lang: en ? 'en' : 'de',
});
